export default __webpack_public_path__ + "static/media/document-upload-success-dark.03b2cb89.png";